import { useEffect, useRef, useState } from "react";
import { EVENT } from "../config";
import { Play, Pause } from "lucide-react";

export const MusicPlayer = () => {
  const audioRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    const a = audioRef.current;
    if (!a) return;
    a.volume = 0.35;
    const tryPlay = () => a.play().then(() => setPlaying(true)).catch(() => {});
    tryPlay();
    const onFirstInteraction = (e) => {
      if (a.paused && !e.target.closest?.('[data-testid="music-toggle"]')) tryPlay();
      window.removeEventListener("pointerdown", onFirstInteraction);
      window.removeEventListener("keydown", onFirstInteraction);
    };
    window.addEventListener("pointerdown", onFirstInteraction);
    window.addEventListener("keydown", onFirstInteraction);
    return () => {
      window.removeEventListener("pointerdown", onFirstInteraction);
      window.removeEventListener("keydown", onFirstInteraction);
    };
  }, []);

  const toggle = () => {
    const a = audioRef.current;
    if (!a) return;
    if (!a.paused) {
      a.pause();
      setPlaying(false);
    } else {
      a.play().then(() => setPlaying(true)).catch(() => setPlaying(false));
    }
  };

  if (!EVENT.musicSrc) return null;

  return (
    <>
      <audio ref={audioRef} src={EVENT.musicSrc} loop preload="auto" />
      <button
        onClick={toggle}
        data-testid="music-toggle"
        aria-label={playing ? "Pause music" : "Play music"}
        className="fixed top-6 right-6 z-50 flex items-center gap-3 rounded-full border border-[#DCD3C0] bg-white/70 py-2.5 pl-2.5 pr-5 backdrop-blur-md transition-colors hover:border-[#7A6A5E]"
      >
        <span className="flex h-9 w-9 items-center justify-center rounded-full bg-[#3F3A32] text-[#F5F1E8]">
          {playing ? <Pause className="h-4 w-4" /> : <Play className="ml-0.5 h-4 w-4" />}
        </span>
        <span className="flex items-center gap-2">
          <span className="hidden text-xs uppercase tracking-[0.15em] text-[#5E574B] sm:inline">
            {playing ? "Playing" : "Play music"}
          </span>
          {playing && (
            <span className="flex items-end gap-0.5" aria-hidden="true">
              {[0, 1, 2].map((i) => (
                <span
                  key={i}
                  className="w-0.5 bg-[#3F3A32]"
                  style={{
                    height: "12px",
                    animation: `eq 0.8s ease-in-out ${i * 0.15}s infinite alternate`,
                  }}
                />
              ))}
            </span>
          )}
        </span>
      </button>
      <style>{`@keyframes eq { from { transform: scaleY(0.3); } to { transform: scaleY(1); } }`}</style>
    </>
  );
};
